import { useNavigate } from 'react-router-dom';

const IconSmall = ({ onClick, interactive = true }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
            return;
        }
        navigate('/home');
    }

    return (
        <img
            src='/icon.png'
            className='appLogo'
            alt='podeux'
            style={{ height: '36px', verticalAlign: 'middle', cursor: interactive ? 'pointer' : undefined }}
            onClick={interactive ? handleClick : undefined}
        />
    );
};

export default IconSmall;
